import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { RegisterAsIndividual } from 'src/app/shared/models/users/register-as-individual';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { getEmailRegExpression } from 'src/app/shared/utils/email-reg';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  busy: boolean = false;
  errorMsg: string = "Looks like something went wrong, please try again";
  showError: boolean = false;
  showSuccess: boolean = false;
  signUp: RegisterAsIndividual = new RegisterAsIndividual();
  emailRegExpression = getEmailRegExpression();

  constructor(private usersService: UserService, private recaptchaV3Service: ReCaptchaV3Service) { }

  ngOnInit(): void {
  }

  public SignUp() {
    this.busy = true;
    this.showError = false;
    this.errorMsg = "";
    this.signUp.displayName = this.signUp.firstName;
    this.signUp.fullName = this.signUp.firstName + " " + this.signUp.lastName;

    if(this.signUp.password != this.signUp.confirmPassword){
      this.showError = true;
          this.errorMsg = "Password fields do not match";
          this.busy = false;
      return;
    }

    this.recaptchaV3Service.execute("RegisterAsIndevidual").subscribe(token => { 
      this.usersService.RegisterAsIndevidual(this.signUp)
      .subscribe(
        (response) => { 
          console.log(response);
        },
        (error) => { 
          this.showError = true;
          this.errorMsg = error.error.ErrorDetail;
          this.busy = false;
        },
        ()=>{
          this.busy = false;
          this.showSuccess = true;
        }
      )
    });
    
  }

}
